/**
 * Convert a UTC date to the user's local timezone.
 * @param {string | Date} utcDate - The UTC date string or Date object.
 * @param {string} formatString - The format string for the output date (not supported natively, simplified here).
 * @returns {string} - The formatted date in the user's local timezone.
 */
export const convertUTCToLocal = (utcDate, formatString = 'yyyy-MM-dd HH:mm:ss') => {
  const date = new Date(utcDate); // Parse the UTC date
  // console.log("UTC date:", date);
  const newDate = date.toLocaleString('en-GB', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false, // Use 24-hour format
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone, // User's local timezone
  });
  // console.log("Formatted date:", newDate);
  return newDate; // Return the formatted date
};

/**
 * Convert a local date to UTC.
 * @param {string | Date} localDate - The local date string or Date object.
 * @param {string} [timeZone] - The local timezone (e.g., 'Africa/Cairo'). Defaults to the user's timezone.
 * @returns {string} - The UTC date in ISO format.
 */
/**
 * Convert a local date to UTC in ISO 8601 format.
 * @param {string | Date} localDate - The local date string or Date object.
 * @returns {string} - The UTC date in ISO 8601 format.
 */
export const convertLocalToUTC = (localDate) => {
  const date = new Date(localDate); // Parse the local date

  // Extract UTC components
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const day = String(date.getUTCDate()).padStart(2, '0');
  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');
  const seconds = String(date.getUTCSeconds()).padStart(2, '0');
  const milliseconds = String(date.getUTCMilliseconds()).padStart(3, '0');

  // Construct the ISO 8601 string
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
};

// export const convertLocalToUTC = (localDate) => {
//   const date = new Date(localDate); // Parse the local date
//   return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString(); // Convert to UTC
// };

// /**
//  * Format a date to a specific timezone.
//  * @param {string | Date} date - The date string or Date object.
//  * @param {string} timeZone - The target timezone (e.g., 'America/New_York').
//  * @returns {string} - The formatted date in the specified timezone.
//  */
// export const formatDateToTimeZone = (date, timeZone) => {
//   const dateObj = new Date(date); // Parse the date
//   // console.log("UTC date:", dateObj);
//   const newDate = dateObj.toLocaleString('en-GB', {
//     year: 'numeric',
//     month: '2-digit',
//     day: '2-digit',
//     hour: '2-digit',
//     minute: '2-digit',
//     second: '2-digit',
//     hour12: false, // Use 24-hour format
//     timeZone, // Target timezone
//   });
//   // console.log("Formatted date:", newDate);
//   return newDate; // Return the formatted date
// };